import { useEffect, useRef, useState } from "react";
import { Back, gsap } from "gsap";

const MouseFollower = () => {
  const mouseFollowerRef = useRef();

  const updateCursorPos = (e) => {
    gsap.to(mouseFollowerRef.current, {
      x: e.clientX,
      y: e.clientY,
      duration: 1.5,
      ease: Back.easeOut.config(2),
    });

    // console.log(
    //   (e.clientX / window.innerWidth) * 100,
    //   (e.clientY / window.innerHeight) * 100
    // );
  };

  useEffect(() => {
    window.addEventListener("mousemove", updateCursorPos);

    document.addEventListener("mouseover", (e) => {
      if (
        e.target !== document.documentElement &&
        e.target.parentElement.classList.contains("e-mf")
      ) {
        gsap.to(mouseFollowerRef.current, {
          backgroundColor: "transparent",
          borderTopWidth: 2,
          borderTopStyle: "solid",
          borderTopColor: "#b7ab98",
          borderBottomWidth: 2,
          borderBottomStyle: "solid",
          borderBottomColor: "#b7ab98",
          borderLeftWidth: 2,
          borderLeftStyle: "solid",
          borderLeftColor: "#b7ab98",
          borderRightWidth: 2,
          borderRightStyle: "solid",
          borderRightColor: "#b7ab98",
          duration: 0.2,
        });

        gsap.to(mouseFollowerRef.current, {
          width: "30rem",
          height: "30rem",
          duration: 0.5,
          ease: "Power1.out",
        });
      }
    });

    document.addEventListener("mouseout", (e) => {
      if (
        e.target !== document.documentElement &&
        e.target.parentElement.classList.contains("e-mf")
      )
        gsap.to(mouseFollowerRef.current, {
          backgroundColor: "#b7ab98",
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          duration: 0.2,
        });

      gsap.to(mouseFollowerRef.current, {
        width: "2rem",
        height: "2rem",

        duration: 0.5,
        ease: "Power1.out",
      });
    });
  });

  return <div className="mouse-follower" ref={mouseFollowerRef}></div>;
};

export default MouseFollower;
